import styled from 'styled-components';
export const Container = styled.div `
  width: 100%;
  display: flex;
  justify-content: space-between;
`;
export const InputWrapper = styled.div `
  ${({ theme }) => theme.media.mobileM `
    margin-right: 0.8rem;
  `};
`;
//# sourceMappingURL=styles.js.map